export default class {
  constructor(element) {
    this.element = element
    this.teaserList = this.findParent(this.element, 'box')

    if (this.teaserList) {
      const links = this.element.getElementsByTagName('a')
      for (let i = 0; i < links.length; i++) {
        links[i].setAttribute(
          'href',
          `${links[i].getAttribute('href')}#${this.teaserList.getAttribute(
            'id',
          )}`,
        )
      }
    }
  }

  findParent(el, cls) {
    while (!el.classList.contains(cls)) {
      el = el.parentElement
    }

    return el
  }
}
